import store from "@/store/index.js";

export default function(showNavbar = true) {
	return function withNavbar(to, from, next) {
		store.commit("SET_SHOW_NAVBAR", showNavbar);
		next();
	};
}
